export enum BrushAction {
  ZOOM = 'zoom',
  // SELECT = 'select',
}
